import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core'; 
import { environment } from '../../../../../environments/environment';
import { Area } from '../../../../core/constants/area';
import { ToastrService } from 'ngx-toastr';
import { ConsoleLogger } from '../../../../core/utilities/console-logger';

@Component({
    selector: 'app-recovery-assets', 
    templateUrl: './recovery-assets.component.html', 
    styleUrls: ['./recovery-assets.component.scss'], 
    encapsulation: ViewEncapsulation.None
})
export class RecoveryAssetsComponent implements OnInit {

    isRunningRecoveryAssetData = false; 

    constructor(
        private http: HttpClient,
        private toastrService: ToastrService
    ) {}

    ngOnInit() {        
    }

    runRecoveryAssetInterestGeneration() {
        this.isRunningRecoveryAssetData = true;
        this.http
            .post<any>(
                `${environment.dotNetApiUrl}/${Area.factoring}/Recovery/GenerateInterestInAll`,
                {}
            )
            .subscribe(
                (x) => {
                    ConsoleLogger.logInfo(x);
                    this.toastrService.success(
                        'Generating recovery asset interest charges was successfully run.'
                    );
                    this.isRunningRecoveryAssetData = false;
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error(
                        'Generating recovery asset interest charges failed to run.'
                    );
                    this.isRunningRecoveryAssetData = false;
                }
            );
    }
}


// WEBPACK FOOTER //
// ./src/app/developer/components/developer-tools/recovery-assets/recovery-assets.component.ts